angular.module('aq.filters.common', [])
.filter('usertime', function () {
    return function (input, user) {
        if (input == null) {
            return '-';
        }
        return moment.utc(input + " UTC").add(user.timeZoneOffsetInMillis, "milliseconds").format('MMMM Do YYYY, h:mm:ss a');
    }
});